import { observer } from 'mobx-react'
import * as React from 'react'
import RootStore from './models/RootModel'
const root = new RootStore()
export const RootContext = React.createContext(root)

const RootProvider = observer(({ children }: any) => {
  return (
    <RootContext.Provider value={root}>
      {children}
    </RootContext.Provider>
  )
})
export default RootProvider